export function getPronoun(survey: IntakeSurvey) {
    const { clientGenderIdentity, clientGenderAtBirth } = survey;
    if (clientGenderIdentity) {
        return clientGenderIdentity.includes('They/Them') ? 'they' : clientGenderIdentity.includes('She/Her') || clientGenderIdentity.includes('Female') ? 'she' : 'he';
    }
    const g = clientGenderAtBirth.toLocaleLowerCase();
    return g === 'male' ? 'he' : g === 'female' ? 'she' : 'they';
}

export function getPossessive(survey: IntakeSurvey) {
    const p = getPronoun(survey);
    return p === 'he' ? 'his' : p === 'she' ? 'her' : 'their';
}

export function formatPdfReportDate(date: Date, isNylPilotAdvisor: boolean) {
    return date.toLocaleDateString('en-US', {
        month: 'long',
        ...(isNylPilotAdvisor ? { day: 'numeric' as const } : {}),
        year: 'numeric',
    });
}

export function getRoiValue(
    source: SelfFundingSource | AnnuitySource | PolicyFundingSource | FundingSources,
    displayType?: PdfRoiDisplayType,
): number | undefined {
    const t = displayType || 'totalROI';
    if ('selfFundingProjectedReturnOnInvestment' in source) {
        const x = source as SelfFundingSource;
        return t === 'IRR' ? x.selfFundingProjectedInternalRateOfReturn : t === 'CAGR' ? x.selfFundingProjectedCompoundAnnualGrowthRate : x.selfFundingProjectedReturnOnInvestment;
    }
    if ('annuityProjectedReturnOnInvestment' in source) {
        const x = source as AnnuitySource;
        return t === 'IRR' ? x.annuityProjectedInternalRateOfReturn : t === 'CAGR' ? x.annuityProjectedCompoundAnnualGrowthRate : x.annuityProjectedReturnOnInvestment;
    }
    if ('policyProjectedReturnOnInvestment' in source) {
        const x = source as PolicyFundingSource;
        return t === 'IRR' ? x.policyProjectedInternalRateOfReturn : t === 'CAGR' ? x.policyProjectedCompoundAnnualGrowthRate : x.policyProjectedReturnOnInvestment;
    }
    const x = source as FundingSources;
    return t === 'IRR' ? x.combinedProjectedInternalRateOfReturn : t === 'CAGR' ? x.combinedProjectedCompoundAnnualGrowthRate : x.combinedProjectedReturnOnInvestment;
}

export function roiLabel(dt: PdfRoiDisplayType, cagr: string) {
    if (dt === 'IRR') return 'IRR (Internal Rate of Return) for Modeled Scenario';
    if (dt === 'CAGR') return `CAGR${cagr} for Modeled Scenario`;
    return 'Return on Investment for Modeled Scenario';
}
